import { BidStatus, type PortalMyBidDto } from "../../../autogen/bff-api";

export interface SettledBid {
  bidId: string;
  status: BidStatus;
}

export const settledOwnBid = (
  bid: PortalMyBidDto,
  canStillDeliver: boolean,
): SettledBid =>
  !canStillDeliver &&
  bid.status === BidStatus.Draft &&
  bid.deliveredBidId &&
  bid.deliveredBidStatus
    ? { bidId: bid.deliveredBidId, status: bid.deliveredBidStatus }
    : { bidId: bid.bidId, status: bid.status };
